import client from '@/http'

const loadAll = (context) => {
  client.get(
    '/scopes'
  ).then(
    (res) => {
      context.commit('SET_SCOPES', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

export default {
  loadAll
}
